"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.starts-with");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _ossUpload = require("@/api/cms/ossUpload");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 图片格式扩展名
var IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.ico'];
var _default2 = {
  name: 'OssUpload',
  props: {
    /** 上传类型：image=图片模式，file=文件模式 */
    uploadType: {
      type: String,
      default: 'image',
      validator: function validator(val) {
        return ['image', 'file'].includes(val);
      }
    },

    /** 是否支持拖拽上传 */
    drag: {
      type: Boolean,
      default: true
    },

    /** 是否禁用 */
    disabled: {
      type: Boolean,
      default: false
    },

    /** 是否支持多文件上传 */
    multiple: {
      type: Boolean,
      default: true
    },

    /** 最大上传文件数量（仅 image 模式） */
    limit: {
      type: Number,
      default: 10
    },

    /** 单个文件大小限制（MB） */
    maxSize: {
      type: Number,
      default: 100
    },

    /** 接收的文件类型，逗号分隔（如 '.jpg,.png,.pdf'） */
    accept: {
      type: String,
      default: ''
    },

    /** OSS 上传目录前缀（如 'crm/contract/'），可选 */
    ossDir: {
      type: String,
      default: ''
    },

    /** 上传提示文字 */
    tipText: {
      type: String,
      default: ''
    },

    /** 初始文件列表（回显用） */
    initFileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      fileList: [],
      previewVisible: false,
      previewUrl: '',
      previewTitle: '',
      previewIsImage: false,
      uploadingCount: 0
    };
  },
  computed: {
    /** 根据 uploadType 和外部 accept 生成最终 accept 字符串 */
    acceptStr: function acceptStr() {
      if (this.accept) return this.accept;

      if (this.uploadType === 'image') {
        return '.jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.ico';
      }

      return '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar,.7z,.txt,.csv';
    }
  },
  watch: {
    initFileList: {
      handler: function handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.setFileList(newVal);
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    /** 判断文件名后缀是否为图片 */
    isImageFile: function isImageFile(file) {
      var name = file.name || file.realName || '';
      var ext = name.substring(name.lastIndexOf('.')).toLowerCase();
      return IMAGE_EXTENSIONS.includes(ext);
    },

    /** 格式化文件大小 */
    formatFileSize: function formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '0 B';
      var k = 1024;
      var sizes = ['B', 'KB', 'MB', 'GB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    /** 触发隐藏的 file input */
    triggerFileInput: function triggerFileInput() {
      var input = this.$refs.fileInput;
      if (!input) return; // 先 click 再重置 value（避免浏览器忽略第一次点击）

      input.click(); // 延迟重置 value，使同一文件可再次选择

      setTimeout(function () {
        input.value = '';
      }, 50);
    },

    /** 原生 file input 选择文件后处理 */
    handleNativeFileChange: function handleNativeFileChange(e) {
      var _this = this;

      var files = e.target.files;
      if (!files || files.length === 0) return; // 转为数组逐个处理

      var _loop = function _loop(i) {
        var rawFile = files[i]; // 大小校验

        var maxBytes = _this.maxSize * 1024 * 1024;

        if (rawFile.size > maxBytes) {
          _this.$message.error("\u6587\u4EF6\u300C".concat(rawFile.name, "\u300D\u5927\u5C0F\u8D85\u8FC7 ").concat(_this.maxSize, "MB \u9650\u5236"));

          return "continue";
        } // 检查是否已达上限


        if (!_this.multiple && _this.fileList.length > 0) return "break";
        if (_this.fileList.length >= _this.limit) return "break"; // 包装文件对象

        var fileObj = {
          uid: Date.now() + '_' + Math.random().toString(36).substr(2, 8),
          name: rawFile.name,
          size: rawFile.size,
          type: rawFile.type,
          raw: rawFile,
          _uploading: false,
          _uploaded: false,
          _percent: 0,
          url: ''
        };

        _this.fileList.push(fileObj); // 立即开始上传


        _this.uploadSingleFile(fileObj).catch(function (e) {
          console.error("\u6587\u4EF6\u300C".concat(fileObj.name, "\u300D\u4E0A\u4F20\u5931\u8D25:"), e);
        });
      };

      for (var i = 0; i < files.length; i++) {
        var _ret = _loop(i);

        if (_ret === "continue") continue;
        if (_ret === "break") break;
      }
    },

    /** 图片加载失败回调 */
    onImageError: function onImageError($event, index) {
      var file = this.fileList[index];

      if (file) {
        console.warn('图片加载失败:', file.url); // 尝试用 window.open 看能不能打开
      }
    },

    /**
     * 上传单个文件到 OSS（直传）
     */
    uploadSingleFile: function () {
      var _uploadSingleFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  // 1. 标记上传中状态
                  _this2.$set(file, '_uploading', true);

                  _this2.$set(file, '_uploaded', false);

                  _this2.$set(file, '_percent', 0); // 2. 请求 OSS 策略（prefix 以后端返回为准）


                  // 2. 请求 OSS 策略（prefix 以后端返回为准）
                  (0, _ossUpload.getOssPolicy)().then(function (policyData) {
                    // policyData 包含: accessKeyId, host, policy, signature, prefix, maxSize, expireSeconds
                    console.log('OSS Policy:', JSON.stringify(policyData));
                    var formData = new FormData(); // 按文件类型分配子目录：图片→upload/image/，文件→upload/file/

                    // 按文件类型分配子目录：图片→upload/image/，文件→upload/file/
                    var subDir = _this2.uploadType === 'image' ? 'upload/image/' : 'upload/file/';

                    var key = subDir + _this2.generateObjectKey(file.name);

                    console.log('OSS upload key:', key);
                    formData.append('key', key);
                    formData.append('OSSAccessKeyId', policyData.accessKeyId);
                    formData.append('policy', policyData.policy);
                    formData.append('signature', policyData.signature); // STS 临时凭证需要附加 securityToken

                    // STS 临时凭证需要附加 securityToken
                    if (policyData.securityToken) {
                      formData.append('x-oss-security-token', policyData.securityToken);
                    } // 让 OSS 返回空响应 204，避免解析 XML


                    // 让 OSS 返回空响应 204，避免解析 XML
                    formData.append('success_action_status', '200'); // 必须传 raw（真正的 File 对象），el-upload 包装对象不含文件二进制数据

                    // 必须传 raw（真正的 File 对象），el-upload 包装对象不含文件二进制数据
                    formData.append('file', file.raw || file); // 3. 创建 XMLHttpRequest 直传 OSS

                    // 3. 创建 XMLHttpRequest 直传 OSS
                    var xhr = new XMLHttpRequest();
                    xhr.open('POST', policyData.host, true);
                    xhr.upload.addEventListener('progress', function (e) {
                      if (e.lengthComputable) {
                        var percent = Math.round(e.loaded / e.total * 100);
                        file._percent = percent;
                      }
                    });
                    xhr.addEventListener('load', function () {
                      if (xhr.status === 200 || xhr.status === 204) {
                        // 4. 上传成功，构建文件信息
                        var fileUrl = "".concat(policyData.host, "/").concat(key);
                        var fileType = _this2.uploadType === 'image' ? '图片' : '附件';
                        var fileInfo = {
                          realName: key,
                          url: fileUrl,
                          name: file.name,
                          localName: file.name,
                          size: file.size,
                          type: fileType
                        };

                        _this2.$set(file, '_uploading', false);

                        _this2.$set(file, '_uploaded', true);

                        _this2.$set(file, '_percent', 100);

                        _this2.$set(file, 'url', fileUrl);

                        _this2.$set(file, 'response', fileInfo);

                        _this2.uploadingCount--; // 5. 触发成功事件

                        // 5. 触发成功事件
                        _this2.$emit('upload-success', fileInfo, _this2.getUploadedFiles());

                        resolve(fileInfo);
                      } else {
                        // 上传失败
                        _this2.$set(file, '_uploading', false);

                        _this2.$set(file, '_uploaded', false);

                        _this2.$set(file, '_percent', 0);

                        _this2.uploadingCount--; // 解析 OSS XML 错误

                        // 解析 OSS XML 错误
                        var ossCode = '';
                        var ossMsg = '';

                        try {
                          var parser = new DOMParser();
                          var xml = parser.parseFromString(xhr.responseText, 'text/xml');
                          var codeEl = xml.querySelector('Code');
                          var msgEl = xml.querySelector('Message');
                          ossCode = codeEl ? codeEl.textContent : '';
                          ossMsg = msgEl ? msgEl.textContent : '';
                        } catch (e) {}

                        var statusText = xhr.status === 0 ? 'CORS/网络错误' : "\u72B6\u6001\u7801: ".concat(xhr.status);
                        var errMsg = ossCode ? "\u4E0A\u4F20\u5931\u8D25 [".concat(ossCode, "] ").concat(ossMsg) : "\u4E0A\u4F20\u5931\u8D25\uFF0C".concat(statusText);
                        console.error('OSS 直传失败:', xhr.status, xhr.responseText);

                        _this2.$message.error(errMsg);

                        _this2.$emit('upload-error', {
                          name: file.name,
                          error: errMsg
                        });

                        reject(new Error(errMsg));
                      }
                    });
                    xhr.addEventListener('error', function () {
                      _this2.$set(file, '_uploading', false);

                      _this2.$set(file, '_uploaded', false);

                      _this2.$set(file, '_percent', 0);

                      _this2.uploadingCount--;
                      var errMsg = "\u7F51\u7EDC\u9519\u8BEF\uFF0C\u4E0A\u4F20\u5931\u8D25";
                      console.error('OSS 直传网络错误');

                      _this2.$message.error(errMsg);

                      _this2.$emit('upload-error', {
                        name: file.name,
                        error: errMsg
                      });

                      reject(new Error(errMsg));
                    });
                    xhr.send(formData);
                  }).catch(function (err) {
                    _this2.$set(file, '_uploading', false);

                    _this2.$set(file, '_uploaded', false);

                    _this2.$set(file, '_percent', 0);

                    _this2.uploadingCount--;
                    var errMsg = '获取 OSS 上传凭证失败';

                    _this2.$message.error(errMsg);

                    _this2.$emit('upload-error', {
                      name: file.name,
                      error: errMsg
                    });

                    reject(err);
                  });
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function uploadSingleFile(_x) {
        return _uploadSingleFile.apply(this, arguments);
      }

      return uploadSingleFile;
    }(),

    /**
     * 生成 OSS 对象键（文件名）
     * 规则：时间戳 + 随机字符串 + 原始扩展名，避免文件名冲突
     * OSS 上使用 hash 方式命名以保证路径兼容性，原始文件名在 name/alias 字段中保留
     */
    generateObjectKey: function generateObjectKey(fileName) {
      var timestamp = Date.now();
      var random = Math.random().toString(36).substr(2, 8);
      var ext = fileName.substring(fileName.lastIndexOf('.'));
      return timestamp + '_' + random + ext;
    },

    /** 删除已上传的文件 */
    handleRemove: function handleRemove(index) {
      var _this3 = this;

      var file = this.fileList[index];
      if (!file) return;
      this.$confirm('确定删除该文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.fileList.splice(index, 1);

        _this3.$emit('delete-success', file, _this3.getUploadedFiles());

        _this3.$message.success('删除成功');
      }).catch(function () {});
    },

    /** 预览文件 */
    previewFile: function previewFile(file) {
      var url = file.url || '';
      var name = file.name || '';
      if (!url) return;

      if (this.isImageFile(file)) {
        this.previewUrl = url;
        this.previewTitle = name;
        this.previewIsImage = true;
        this.previewVisible = true;
      } else {
        // 非图片文件，用 a 标签下载（避免弹窗拦截）
        this.downloadFile(url, name);
      }
    },

    /** 下载文件（通过 fetch + blob 避免跨域导致文件名丢失） */
    downloadFile: function downloadFile(url, fileName) {
      var defaultName = fileName || 'download'; // 同源或 data: URI 可直接用 a.download

      if (url.startsWith('data:') || url.startsWith('blob:') || url.indexOf(location.origin) === 0) {
        var a = document.createElement('a');
        a.href = url;
        a.download = defaultName;
        a.target = '_blank';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        return;
      } // 跨域 URL：先 fetch 成 blob 再下载，确保文件名可控


      fetch(url, {
        mode: 'cors'
      }).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        var blobUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = defaultName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function () {
          return URL.revokeObjectURL(blobUrl);
        }, 10000);
      }).catch(function () {
        // 降级：直接用 a 标签下载（文件名可能为 OSS key）
        var a = document.createElement('a');
        a.href = url;
        a.download = defaultName;
        a.target = '_blank';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    },

    /** 获取当前已上传文件列表 */
    getUploadedFiles: function getUploadedFiles() {
      return this.fileList.filter(function (f) {
        return f._uploaded && f.response;
      }).map(function (f) {
        return f.response;
      });
    },

    /** 获取所有文件（含未上传） */
    getAllFiles: function getAllFiles() {
      return this.fileList;
    },

    /** 外部设置文件列表（用于回显） */
    setFileList: function setFileList(files) {
      var _this4 = this;

      this.fileList = files.map(function (f) {
        // 优先使用原始文件名，OSS key（realName）仅用于拼接 URL
        var displayName = f.name || f.alias || f.localName || f.realName || '';
        var url = f.url || '';
        return {
          name: displayName,
          url: url,
          realName: f.realName || '',
          size: f.size || 0,
          _uploaded: true,
          _uploading: false,
          _percent: 100,
          response: {
            realName: f.realName || '',
            url: url,
            name: displayName,
            alias: f.alias || displayName,
            localName: f.localName || displayName,
            type: f.type || (_this4.uploadType === 'image' ? '图片' : '附件'),
            size: f.size || 0
          }
        };
      });
    },

    /** 清空文件列表 */
    clearFiles: function clearFiles() {
      this.fileList = [];
    },

    /** 重置上传状态 */
    reset: function reset() {
      this.fileList = [];
      this.uploadingCount = 0;
    }
  }
};
exports.default = _default2;